export class BuyerRefNoRequest{
    buyerRefNo:string;
    userId:number;
    buyerId?:number;
    email?:string;
    role?:string;




    // constructor(buyerRefNo:number){
    //     this.buyerRefNo = buyerRefNo
    // }
}

export class UpdateIdReq{
    id:number;
    m3ItemsId?: number
    constructor(id:number,m3ItemsId?: number){
        this.id = id
        this.m3ItemsId = m3ItemsId
    }
}